import APIRequest from '../api/APIRequest';

// Simple in-memory storage for classes
let classes = [];

export const classService = {
  // Get all classes
  getAllClasses:async (token) => {
    try {
    const api = new APIRequest();
    const response = await api.request('/admin/getAllClasses', 'GET', {}, token);
    if(response.success){
      return response.classes;
    }else{
      return [];
    }
    } catch (error) {
      return [];
    }
  },

  // Get class by ID
  getClassById: (id) => {
    return classes.find(cls => cls.id === id);
  },

  // Add new class
  addClass: (newClass) => {
    classes.push(newClass);
    return newClass;
  },

  // Update class
  updateClass: (id, updatedClass) => {
    const index = classes.findIndex(cls => cls.id === id);
    if (index !== -1) {
      classes[index] = { ...classes[index], ...updatedClass };
      return classes[index];
    }
    return null;
  },

  // Delete class
  deleteClass: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/deleteClass?id=${id}`, 'DELETE', {}, token);
      return response;
    } catch (error) {
      console.error('Error deleting class:', error);
      return { success: false, message: 'Failed to delete class' };
    }
  }
};
